import { SummaryItem } from '@renderer/chat'
import { ReactNode } from 'react'
import { SummaryContext, SummaryContextValue } from '../hooks/use-summary-context'

interface SummaryProviderProps {
  summary: SummaryItem
  isExpanded?: boolean
  setExpanded?: (expanded: boolean) => void
  isEditing?: boolean
  setEditing?: (editing: boolean) => void
  edited?: string | undefined
  setEdited?: (edited: string | undefined) => void
  isGenerating?: boolean
  setIsGenerating?: (generating: boolean) => void
  hasInteracted?: boolean
  children: ReactNode
}

const noop = () => {}

export function SummaryProvider({
  summary,
  isExpanded = false,
  setExpanded = noop,
  isEditing = false,
  setEditing = noop,
  edited = undefined,
  setEdited = noop,
  isGenerating = false,
  setIsGenerating = noop,
  hasInteracted = false,
  children,
}: SummaryProviderProps) {
  const value: SummaryContextValue = {
    summary,
    isExpanded,
    setExpanded,
    isEditing,
    setEditing,
    edited,
    setEdited,
    isGenerating,
    setIsGenerating,
    hasInteracted,
  }

  return <SummaryContext.Provider value={value}>{children}</SummaryContext.Provider>
}
